module.exports = __webpack_public_path__ + "media/images/850/sleep_paralysis_night_mare-e3ce575d3e6ba6b4fdba02831c840219.webp";